export default "__VITE_ASSET__78VX892___"